var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" d-flex flex-column flex-xl-row"},[_c('GroupMemberNav',{staticClass:"slide-down-95-percent animation-xl-none"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }